module.exports = __webpack_public_path__ + "static/media/preventivo_amarillo.524e0a86.svg";